import { createSelector } from 'reselect'

export const getLastVersionSelector = createSelector(
  state => state.app.lastVersion,
  version => version ?? 'NEW_LOAD',
)
